import ValueItemCard from "@/components/v2/atoms/landing/about/ValueItemCard";
import { TranslationKey } from "@/types/translations";

interface AboutValuesProps {
  translate: (key: TranslationKey) => string;
}

interface ValueItem {
  icon: string;
  titleKey: TranslationKey;
  descriptionKey: TranslationKey;
}

const values: ValueItem[] = [
  {
    icon: "🏔️",
    titleKey: "about.values.excellence.title",
    descriptionKey: "about.values.excellence.description",
  },
  {
    icon: "🤝",
    titleKey: "about.values.hospitality.title",
    descriptionKey: "about.values.hospitality.description",
  },
  {
    icon: "🌿",
    titleKey: "about.values.sustainability.title",
    descriptionKey: "about.values.sustainability.description",
  },
];

const AboutValues = ({ translate }: AboutValuesProps) => (
  <section className="py-16 md:py-20 bg-white">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-center mb-12 md:mb-16">
        <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4">
          {translate("about.values.title")}
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12">
        {values.map(({ icon, titleKey, descriptionKey }) => (
          <ValueItemCard
            key={titleKey}
            icon={icon}
            title={translate(titleKey)}
            description={translate(descriptionKey)}
          />
        ))}
      </div>
    </div>
  </section>
);

export default AboutValues;
